import { Component, OnDestroy } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '../../strategy.actions';
import * as fromAppRoot from '../../../../app.reducers';
import * as fromStrategy from '../../reducers';

import { TrackingService } from 'src/app/modules/shared/services/tracking.service';

@Component({
  selector: 'app-strategy-portfolio-topics-criteria',
  templateUrl: './strategy-portfolio-topics-criteria.component.html',
  styleUrls: ['./strategy-portfolio-topics-criteria.component.scss'],
  standalone: false
})
export class StrategyPortfolioTopicsCriteriaComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  editMode = false;
  customerCriteria = [];
  footPrintTopics = [];
  handPrintTopics = [];
  isTopicsLoading: boolean;
  otherTopics = [];

  constructor(
    private store: Store,
    private trackingService: TrackingService
  ) {
    this.store.pipe(select(fromAppRoot.selectCurrentAccountEditMode), takeUntil(this.onDestroy$)).subscribe((editMode) => {
      this.editMode = editMode;
    });

    this.store.pipe(select(fromStrategy.selectCustomerCriteria), takeUntil(this.onDestroy$)).subscribe((customerCriteria) => {
      this.customerCriteria = customerCriteria;
    });

    this.store.pipe(select(fromStrategy.selectTopicsLoader), takeUntil(this.onDestroy$)).subscribe((loading) => {
      this.isTopicsLoading = loading;
    });

    this.store.pipe(select(fromStrategy.selectCustomerTopicsData), takeUntil(this.onDestroy$)).subscribe((topics) => {
      this.handPrintTopics = [];
      this.footPrintTopics = [];
      this.otherTopics = [];

      topics.forEach((topic) => {
        if (topic.print_type !== 'Handprint' && topic.print_type !== 'Footprint' && topic.id !== 32) {
          this.otherTopics = [...this.otherTopics, topic];
        } else if (topic.print_type === 'Handprint') {
          this.handPrintTopics = [...this.handPrintTopics, topic];
        } else if (topic.print_type === 'Footprint') {
          this.footPrintTopics = [...this.footPrintTopics, topic];
        }
      });
    });
  }

  openTopics(): void {
    this.trackingService.trackActivity('[Button] Select impact topics');
    this.store.dispatch(StrategyActions.setTabIndex({ tabIndex: 1 }));
  }

  trackActivity(activity: string): void {
    this.trackingService.trackActivity(activity);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
